// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__NZLUa","left":"InfoRow_left__1HGyf"};